import { api } from "./axios.config";
import axios from "./axios";

const API_URL = api.apiUrl;
const BASE_URL = "/event/";
const eventId = window.location.href;
const Organizer_base = "/organiser";
const orgId = `?organiser_id=${localStorage.getItem("user")}`;

export const getOrganizerDetails = (eventId) => {
    return axios.get(API_URL + BASE_URL + eventId + Organizer_base + orgId);
};

export const getOrganizers = (eventId) => {
    return axios.get(API_URL + BASE_URL + eventId + Organizer_base + orgId);
};

export const postNewOrganizerDetails = (eventId, payload, token, auth_token) => {
    return axios.post(API_URL + BASE_URL + eventId + Organizer_base, payload);
};

export const deleteNewOrganizer = (eventId, email_id) => {
    return axios.delete(
        API_URL +
        BASE_URL +
        eventId +
        Organizer_base +
        `/${email_id}`
    );
};

export const transferOwner = (eventId, payload) => {
    return axios.put(API_URL + BASE_URL + eventId + '/organiser', payload);
};

export const editNotification = (eventId, payload) => {
    return axios.put(API_URL + BASE_URL + eventId + '/organiser/' + 'notifications', payload);
};


